import { APICallV4Post } from 'reactApp/api/APICall';

export class CancelFilesMigrationAPICall extends APICallV4Post {
    _method = 'private/tgmig/cancel';
}
